import {useState, useCallback} from "react";
import {
  NavigationBlockState,
  NavigationActions,
} from "../types/NavigationBlocks";

export const useNavigationBlocks = (): NavigationActions & {
  currentBlock: NavigationBlockState | null;
  navigationStack: NavigationBlockState[];
} => {
  const [navigationStack, setNavigationStack] = useState<
    NavigationBlockState[]
  >([]);

  const pushBlock = useCallback((block: NavigationBlockState) => {
    setNavigationStack((prev) => [...prev, block]);
  }, []);

  const popBlock = useCallback((): NavigationBlockState | null => {
    if (navigationStack.length <= 1) {
      return null;
    }

    const removedBlock = navigationStack[navigationStack.length - 1];

    setNavigationStack((prev) => prev.slice(0, -1));
    return removedBlock;
  }, [navigationStack]);

  const getCurrentBlock = useCallback((): NavigationBlockState | null => {
    return navigationStack.length > 0
      ? navigationStack[navigationStack.length - 1]
      : null;
  }, [navigationStack]);

  const canGoBack = useCallback((): boolean => {
    return navigationStack.length > 1;
  }, [navigationStack]);

  const resetToRoot = useCallback(() => {
    if (navigationStack.length > 0) {
      setNavigationStack([navigationStack[0]]);
    }
  }, [navigationStack]);

  return {
    pushBlock,
    popBlock,
    getCurrentBlock,
    canGoBack,
    resetToRoot,
    currentBlock: getCurrentBlock(),
    navigationStack,
  };
};
